import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import RenderLabel from "./RenderLabel";
import RenderWidgets from "./RenderWigets";
import { SubmitButtons } from "./RenderForm";
import { Container } from "@/common/ui/container";
import { Col } from "@/common/css";
import { getNestedValue } from "@/utils/helper/form";
import { useFormChangeWarning } from "@/hooks/useFormChangeWarning";
import { EMPLOYEE_STATUS } from "@/utils/constant/global.constant";

interface RenderFormForModalProps {
  formConfig: any;
  handleFormSubmit: (data: any) => void;
  className?: string;
  formClassName?: string;
  // Use in the Modal
  handleCancel?: () => void;
  btnContainerClass?: string;
  defaultValues?: any;
  isAlert?: boolean;
}

const RenderFormForModal: React.FC<RenderFormForModalProps> = ({
  formConfig,
  handleFormSubmit,
  handleCancel,
  className = "p-6 shadow-form border-1",
  formClassName = "pt-6",
  btnContainerClass,
  defaultValues,
  isAlert,
}) => {
  const methods = useForm({ mode: "all", reValidateMode: "onChange" });
  const {
    handleSubmit,
    // watch,
    getValues,
    formState: { isSubmitting, dirtyFields, isSubmitSuccessful },
  } = methods;
  const isDirty = Boolean(Object.keys(dirtyFields).length);
  // console.log({ W: watch() });
  useFormChangeWarning(isDirty, isSubmitSuccessful);

  return (
    <Container.ContentBox className={className} key={`render-form-${formConfig?.formKey}`}>
      {formConfig?.formName && <h2 className="font-bold text-2xl text-center text-text-label px-4">{formConfig.formName}</h2>}
      <FormProvider {...methods}>
        <form className={`flex flex-col items-center md:items-start w-full h-full gap-y-3 ${formClassName}`} onSubmit={handleSubmit(handleFormSubmit)}>
          <Col className="w-full h-[calc(100%-48px)]">
            <Container.Content className="px-4 w-full h-full overflow-y-auto flex flex-col gap-y-4">
              {formConfig.sections.map((section: any, sectionIndex: number) => (
                <div className="flex flex-wrap w-full gap-x-30 gap-y-4" key={sectionIndex}>
                  {section.widgets?.map((widget: any) => {
                    let loopData = undefined;
                    let forceDisabled = undefined;

                    if (widget?.apiField === "base") {
                      loopData = defaultValues;
                    }
                    if (widget?.dependentField) {
                      const dependentFieldValue = methods.watch(widget.dependentField);
                      const shouldHideWidget = !dependentFieldValue || (widget?.dependentFieldValue && widget.dependentFieldValue !== dependentFieldValue);
                      if (shouldHideWidget) return null;
                    }
                    if (formConfig?.formKey === "add-signatory" && widget.field === "authorizedDoc" && defaultValues) {
                      loopData = getNestedValue(defaultValues, widget.apiField);
                    }
                    if (formConfig?.formKey === "edit-employee" && widget.field === "supportingDoc" && defaultValues) {
                      loopData = getNestedValue(defaultValues, widget.apiField);
                    }
                    if (
                      formConfig?.formKey === "edit-employee" &&
                      getValues("status") === EMPLOYEE_STATUS["Ex-employee"] &&
                      ["empId", "status", "userType", "fullName", "empType", "empEmail", "aadharNumber", "panNumber"].includes(widget.field)
                    ) {
                      forceDisabled = true;
                    }
                    if (formConfig?.formKey === "edit-employee" && getValues("userType") === 1000001 && widget.field === "userType") {
                      forceDisabled = true;
                    }
                    let defaultValue = getNestedValue(defaultValues, widget?.apiField ? widget.apiField : widget?.field);
                    if (formConfig?.formKey === "exit" && defaultValues?.strtDt && widget.field === "employmentPeriod") {
                      defaultValue = { startDate: defaultValues?.strtDt };
                    }
                    // console.log({ defaultValue, defaultValues, widget });
                    return (
                      <div className={`flex flex-col ${formConfig?.widgetsClass ? formConfig.widgetsClass : "w-full"}  gap-1`} key={widget?.field}>
                        {formConfig?.showLabel && !widget?.hideLabel && (
                          <RenderLabel label={widget.label} required={widget?.validation?.required} labelInfo={widget?.labelInfo} className="text-nowrap " />
                        )}
                        <RenderWidgets widget={widget} defaultValue={defaultValue} loopData={loopData} forceDisabled={forceDisabled} />
                      </div>
                    );
                  })}
                </div>
              ))}
            </Container.Content>
            <Container.Content className="!p-0">
              <Container.Separator />
              {/* submit Button */}
              <SubmitButtons
                handleCancel={handleCancel}
                isSubmitting={isSubmitting}
                submitBtnText={formConfig?.submitBtnText}
                cancelBtnText={formConfig?.cancelBtnText}
                btnContainerClass={btnContainerClass}
                isAlert={isAlert}
                isDisabled={!isDirty}
              />
            </Container.Content>
          </Col>
        </form>
      </FormProvider>
    </Container.ContentBox>
  );
};

export default RenderFormForModal;
